import React from "react";

function RecentStakes() {
  return <div>RecentStakes</div>;
}

export default RecentStakes;
